import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import Icon from '../../Components/Icons/Icon';
import { classNames, useNewWindow } from '../../Services/helpers';
import { useHelp } from '../../Components/Help';
import { useNavigate } from 'react-router-dom';
import { useSyncedPreference } from '../../Data/Preference';
import { useSession } from '../../Components/Session';

const Help = () => {
    const {openLiveChat} = useHelp();
    const [restoreId, setRestoreId] = useSyncedPreference('freshchatRestoreId', null);
    const {isAdmin} = useSession();

    return <>
        <TopBar left="/more" title="Getting Started" />
        <Page>
            <div className="mb-6 w-full flex flex-col justify-center gap-4">
                <Card icon="Video"
                    description="Watch our videos to help you get started with getSoapy"
                    to="/help/videos"
                />
                <Card icon="ListCheck"
                    description="Follow our getting started checklist"
                    to="/help/checklist"
                />
                <Card icon="FileLines"
                    description={<>Read our documentation to learn more about how to use our app <Icon icon="LinkExternal" size="0.5x" className="ml-1" /></>}
                    open="https://getsoapy.com/docs"
                />
                <Card icon="Robot"
                    description="Ask our bot any question and get an instant answer"
                    to="/help/question"
                />
                <Card icon="UserHelmetSafety"
                    description="Speak to our human support team who can solve any issues you have"
                    onClick={openLiveChat}
                />

                {(isAdmin() && !!restoreId) && <div className="w-full lg:w-4/5 mx-auto mt-[100vh] border border-red-200 p-4 rounded-lg flex flex-row gap-4 items-center justify-start">
                    <Icon icon="Trash" size="2x" className="fill-muted" />
                    <p className="text-xs text-muted"
                            onClick={async () => {
                                await setRestoreId(null);
                                window.location.reload();
                            }}
                        >
                        Reset the help chat session. Experimental.<br />
                        This can help stop it popping up after the conversation is closed.
                    </p>
                </div>}
            </div>
        </Page>
    </>
}

const Card = ({icon, description, to, open, onClick}) => {
    const newWindow = useNewWindow();
    const navigate = useNavigate();

    const handleClick = () => {
        to && navigate(to);
        open && newWindow(open);
        onClick && onClick();
    }

    return <div className={classNames(
                'rounded-lg p-4 border border-slate-300 bg-slate-100 text-slate-900',
                'flex flex-row gap-4 items-center justify-start',
                'w-full lg:w-4/5 mx-auto',
            )}
            onClick={handleClick}
        >
        <Icon icon={icon} size="4x" className="fill-brand" />
        <div className="prose prose-slate prose-sm text-balance fill-slate-800">
            <p className="my-0">
                {description}
            </p>
        </div>
    </div>
}

export default Help;